// import 'v-calendar/lib/v-calendar.min.css'
import Vcalendar from 'v-calendar'
import Vue from 'vue'

Vue.use(Vcalendar, { datePickerTintColor: '#F00' })
